import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 } from '../../styles/typography/typography';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_NEUTRAL_GREY_700, PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_WHITE } from '../../styles/colors/colors';
import { EmbersMenuLaunchButton } from '../../menu/menuLaunchButton';
export var MiniSelectLaunchButton = styled(EmbersMenuLaunchButton)(_objectSpread(_objectSpread({
  height: 32
}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
  border: '1px solid ' + PROMETHEAN_NEUTRAL_GREY_700,
  display: 'inline-block',
  textAlign: 'start',
  whiteSpace: 'nowrap',
  backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
  borderRadius: 4,
  paddingLeft: 7,
  paddingRight: 30,
  paddingTop: 0,
  position: 'relative',
  userSelect: 'none',
  outline: 'none',
  cursor: 'pointer',
  flexShrink: 0,
  '&.EmbersMiniSelectLaunchButton-disabled': {
    borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
    color: PROMETHEAN_NEUTRAL_DARK_GREY,
    pointerEvents: 'none'
  },
  '&.EmbersMiniSelectLaunchButton-hasFocus&:not(&.EmbersMiniSelectLaunchButton-dark)&.Mui-focusVisible': {
    border: '2px solid ' + PROMETHEAN_BLUE,
    paddingLeft: 6,
    paddingRight: 29,
    '.EmbersMiniSelectLaunchButton-rightIcon': {
      top: 2,
      right: 5.5
    }
  },
  '&.EmbersMiniSelectLaunchButton-hasFocus&:not(&.EmbersMiniSelectLaunchButton-dark)&:active': {
    border: '2px solid ' + PROMETHEAN_BLUE,
    paddingLeft: 6,
    paddingRight: 29,
    '.EmbersMiniSelectLaunchButton-rightIcon': {
      top: 2,
      right: 5.5
    }
  },
  '&:active': {
    border: '1px solid ' + PROMETHEAN_PURPLE_GRAPE
  },
  '&.EmbersMiniSelectLaunchButton-menuOpen': {
    border: '1px solid ' + PROMETHEAN_PURPLE_GRAPE
  },
  '&.EmbersMiniSelectLaunchButton-dark': {
    borderWidth: 0,
    '.EmbersMiniSelectLaunchButton-rightIcon': {
      top: 4,
      right: 7.5
    },
    '&.Mui-focusVisible': {
      border: '2px solid ' + PROMETHEAN_NEUTRAL_WHITE,
      outline: '1px solid ' + PROMETHEAN_PURPLE_GRAPE,
      outlineOffset: -2,
      paddingLeft: 5,
      paddingRight: 28,
      '.EmbersMiniSelectLaunchButton-rightIcon': {
        top: 2,
        right: 5.5
      }
    },
    '&:active': {
      border: '2px solid ' + PROMETHEAN_PURPLE_GRAPE,
      paddingLeft: 5,
      paddingRight: 28,
      '.EmbersMiniSelectLaunchButton-rightIcon': {
        top: 2,
        right: 5.5
      }
    },
    '&.EmbersMiniSelectLaunchButton-menuOpen': {
      border: '2px solid ' + PROMETHEAN_PURPLE_GRAPE,
      paddingLeft: 5,
      paddingRight: 28,
      '.EmbersMiniSelectLaunchButton-rightIcon': {
        top: 2,
        right: 5.5
      }
    }
  },
  '.EmbersMiniSelectLaunchButton-label': {
    marginRight: 5
  },
  '.EmbersMiniSelectLaunchButton-rightIcon': {
    position: 'absolute',
    top: 3,
    right: 6.5,
    width: 24,
    height: 24
  },
  '.EmbersMiniSelectLaunchButton-tag': {
    color: PROMETHEAN_PURPLE_GRAPE,
    height: 15,
    width: 15,
    fontSize: 20,
    marginTop: 1,
    marginRight: 4,
    pointerEvents: 'none'
  }
}));
export var miniSelectTheme = createTheme({
  components: {
    MuiList: {
      styleOverrides: {
        root: {
          outline: 'none'
        }
      }
    },
    MuiCollapse: {
      styleOverrides: {
        wrapperInner: {
          margin: '0 12px 0 8px'
        }
      }
    }
  }
});